import { Component, inject, OnInit } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { ServicioFavicon } from '@core/services/favicon/favicon.service';
import { SpinnerCargaComponent } from '@core/components/spinner-carga/spinner-carga.component';
import { LoadingService } from '@core/services/ui/loading.service';
import { RecaptchaChallengeComponent } from '@core/services/recaptcha/recaptcha-challenge.component';
import { AtajoPuntoService } from '@core/services/atajo-punto/atajo-punto.service';
import { ErrorConexionService } from '@core/services/error-conexion/error-conexion.service';
import { SesionCerradaService } from '@core/services/sesion-cerrada/sesion-cerrada.service';
import { LimpiezaSesionService } from '@core/services/limpieza-sesion/limpieza-sesion.service';
import { ModalMensajeServicioComponent } from '@shared/components/modal-mensaje-servicio/modal-mensaje-servicio.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SpinnerCargaComponent, RecaptchaChallengeComponent, ModalMensajeServicioComponent],
  template: `
    <router-outlet />
    <app-spinner-carga />
    <app-recaptcha-challenge />
    @if (errorConexion.mensaje()) {
      <app-modal-mensaje-servicio
        [mensaje]="errorConexion.mensaje()!"
        [visible]="errorConexion.visible()"
        (accion)="errorConexion.ocultar()"
      />
    }
    @if (sesionCerrada.mensaje()) {
      <app-modal-mensaje-servicio
        [mensaje]="sesionCerrada.mensaje()!"
        [visible]="sesionCerrada.visible()"
        [urlIconoCerrar]="sesionCerrada.mensaje()!.urlIconoCerrar ?? null"
        [urlIconoAlerta]="sesionCerrada.mensaje()!.urlIconoAlerta ?? null"
        [varianteBoton]="'primario'"
        (accion)="limpiezaSesionService.cerrarSesionYSalir()"
      />
    }
  `,
})
export class AppComponent implements OnInit {
  protected readonly errorConexion = inject(ErrorConexionService);
  protected readonly sesionCerrada = inject(SesionCerradaService);
  protected readonly limpiezaSesionService = inject(LimpiezaSesionService);
  private readonly servicioFavicon = inject(ServicioFavicon);
  private readonly router = inject(Router);
  private readonly loadingService = inject(LoadingService);
  private readonly atajoPuntoService = inject(AtajoPuntoService);

  public ngOnInit(): void {
    this.servicioFavicon.cargarFaviconDesdeCMS().subscribe();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loadingService.mostrar();
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loadingService.ocultar();
      }
    });
  }
}
